"use strict";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CarInfoIcon, HomeIcon, UpdateIcon } from '@autoguru/icons';
import { tenantMap } from '@autoguru/tenant-selector';
import { CDN, TENANT_NAME } from '@autoguru/global-configs';
export const useDEPortalAsideItems = t0 => {
  const $ = _c(15);
  const {
    baseUrl
  } = t0;
  let t1;
  let t2;
  if ($[0] !== baseUrl) {
    t2 = [{
      links: [{
        label: "Home",
        icon: HomeIcon,
        to: baseUrl
      }]
    }];
    $[0] = baseUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${baseUrl}/updates`;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      label: "Updates",
      icon: UpdateIcon,
      to: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `${baseUrl}/rego`;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      label: "Rego",
      icon: CarInfoIcon,
      to: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = [{
      links: [t4, t6]
    }];
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `${baseUrl}/global-tenant`;
  let t9;
  if ($[9] !== t8) {
    t9 = [{
      links: [{
        label: tenantMap[TENANT_NAME].label,
        iconSrc: `${CDN}/images/tenant/icon/round/${tenantMap[TENANT_NAME].code}.svg`,
        to: t8
      }]
    }];
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t2 || $[12] !== t7 || $[13] !== t9) {
    t10 = {
      header: t2,
      body: t7,
      footer: t9
    };
    $[11] = t2;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  t1 = t10;
  return t1;
};